import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgDownload(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M12 0.00134277C11.4477 0.00134277 11 0.448557 11 1.00022V11.2896L8.46447 8.75693C8.07394 8.36685 7.44078 8.36685 7.05025 8.75693C6.65973 9.14702 6.65973 9.77948 7.05025 10.1696L10.5858 13.7011C11.3668 14.4813 12.6332 14.4813 13.4142 13.7011L16.9497 10.1696C17.3403 9.77948 17.3403 9.14702 16.9497 8.75693C16.5592 8.36685 15.9261 8.36685 15.5355 8.75693L13 11.2896V1.00022C13 0.448557 12.5523 0.00134277 12 0.00134277Z", fill: "currentColor" }),
        React.createElement("path", { d: "M4 22.0013C2.89543 22.0013 2 21.1069 2 20.0036V14.0092C2 13.4575 2.44772 13.0103 3 13.0103C3.55228 13.0103 4 13.4575 4 14.0092V20.0036H20V14.0092C20 13.4575 20.4477 13.0103 21 13.0103C21.5523 13.0103 22 13.4575 22 14.0092V20.0036C22 21.1069 21.1046 22.0013 20 22.0013H4Z", fill: "currentColor" })));
}
export default SvgDownload;
